import React, { useEffect, useState } from "react";
import { FormGroup } from "react-bootstrap";
import { BackendURL } from "../../../../Constants/AppData";
import Autosuggest from 'react-autosuggest';
import styled from "styled-components";
import { WerfenColor5 } from "../../../../Constants/ColorChart";
import useDebounce from "../../../Sensors/useDebounce";

const StyledFormGroup = styled( FormGroup )`
    .react-autosuggest__container ul {
        position: absolute;
        background: white;
        border: 1px solid #ced4da;
        padding: 10px 0px;
        list-style: none;
        border-radius: 5px;
        box-shadow: 0 0 10px 0px #aaafb3;
        margin-top: 4px;
    }
    .react-autosuggest__container li {
        padding: 0 10px 10px;
        border-bottom: 1px solid #ced4da;
        margin-bottom: 10px;
    
    }
    .react-autosuggest__container li .user{
        padding: 10px;
    }
    .react-autosuggest__container li:last-of-type {
        padding-bottom:0;
        border-bottom: 0 none transparent;
        margin-bottom: 0;
    }
    
    .react-autosuggest__container li .user:hover {
        background: ${ WerfenColor5 };
        cursor: pointer;
    }
    .infoPanel {
        padding:  20px;
        position: absolute;
        max-width: 250px;
        background: white;
        border: 1px solid #ced4da;
        border-radius: 5px;
        box-shadow: 0 0 10px 0px #aaafb3;
        margin-top: 4px;
    }
`

const AutosuggestField = (props) => {
    const [ isError, setIsError ] = useState( false );
    const [ isLoading, setIsLoading ] = useState( false );
    const [ showInfoPanel, setShowInfoPanel ] = useState( false );
    const [ value, setValue ] = useState( props.uname || '' );
    const [ suggestions, setSuggestions ] = useState( [] );
    const [ message, setMessage ] = useState( '' );
    const [ selectedId, setSelectedId ] = useState( props.uuid || '' );
    const debouncedValue = useDebounce(value, 350);

    useEffect( () => {
        setValue(debouncedValue)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ debouncedValue ] );

    const onChange = ( event, { newValue } ) => {
        setValue(newValue);
    }

    const renderSuggestion = ( suggestion ) => {
        return <div className="user">
            <div className="user-meta">
                <div className="user-name"><b>{ suggestion.name }</b></div>
                <div className="user-display_name"><i>{ suggestion.display_name }</i></div>
                <div className="user-uud"><small>{ suggestion.sales_org_name }</small></div>
            </div>
        </div>
    }

    const getSuggestionValue = ( itemSelected ) => {
        // console.info(itemSelected);
        return itemSelected.name
    };

    const getSuggestions = ( search, page, prev ) => {
        // console.info("getSuggestions", search);
        if ( search && search.length > 2 ) {
            setIsLoading(true);
            setIsError(false);
            setShowInfoPanel(true);
            setMessage('Searching for users...');

            let url = BackendURL + '/jsonapi/user/user?' +
                'include=field_user_sales_org,employee_sap_profiles&' +
                'filter[anon][condition][path]=uid&' +
                'filter[anon][condition][value]=0' +
                '&filter[anon][condition][operator]=<>&' +
                'filter[name-filter][condition][path]=name&' +
                'filter[name-filter][condition][operator]=CONTAINS&' +
                'filter[name-filter][condition][value]=' +
                encodeURIComponent( search )

            const myHeaders = new Headers();
            myHeaders.append( "Authorization", "Bearer " + window.localStorage.getItem( "token" ) );
            const requestOptions = {
                method: 'GET',
                headers: myHeaders,
                redirect: 'follow'
            };
            // if (page) {
            //     url += '&page=' + page
            // }
            fetch( url, requestOptions )
                .then( response => {
                    if ( response.ok ) {
                        return response.json()
                    } else {
                        setIsLoading(false);
                        setIsError(true);
                        setShowInfoPanel(true);
                        setSuggestions([]);
                        setMessage('User search returned error: ' + response.statusText);
                    }
                }, err => {
                    setIsLoading(false);
                    setIsError(true);
                    setShowInfoPanel(true);
                    setSuggestions([]);
                    setMessage('User search failed: ' + err.message);
                } )
                .then( ( json ) => {
                    const salesOrgs = props.salesOrgsList

                    const filteredList = json.data
                        .filter( item => item.relationships.employee_sap_profiles.data !== null )
                        .map( item => {
                            return {
                                id: item.relationships.employee_sap_profiles.data.id,
                                userId: item.id,
                                name: item.attributes.name,
                            }
                        } )

                    const profilesList = json.included
                        .filter( item => item.type === "profile--employee_sap" )
                        .map( item => {
                            const salesOrgId = item.relationships.field_employee_sap_sales_org.data.id;
                            return {
                                id: item.id,
                                display_name: item.attributes.field_employee_sap_fullname,
                                email: item.attributes.field_employee_sap_email,
                                phone: item.attributes.field_employee_sap_phone,
                                sales_org_id: salesOrgId,
                                sales_org_name: salesOrgId ? salesOrgs.find( item => item.id === salesOrgId ).name : ""
                            }
                        } )

                    const normalizedUserList = filteredList
                        .map( item => {
                            const profileFound = profilesList.find( profile => profile.id === item.id );
                            return {
                                id: item.userId,
                                name: item.name,
                                display_name: profileFound.display_name,
                                email: profileFound.email,
                                phone: profileFound.phone,
                                sales_org_id: profileFound.sales_org_id,
                                sales_org_name: profileFound.sales_org_name.replace( "Werfen ", "" )
                            }
                        } )


                    let users = [];
                    let responseMessage = '';
                    if ( normalizedUserList.length === 0 ) {
                        responseMessage = 'No matching entries found'
                    } else {
                        users = prev ? prev.concat( normalizedUserList ) : normalizedUserList
                    }
                    setIsLoading(false);
                    setIsError(false);
                    setShowInfoPanel(message !== "");
                    setSuggestions(users);
                    setMessage(responseMessage);

                    // Auto Match
                    if ( users.length === 1 ) {
                        processSelection( users[0] );
                    }
                } )
                .catch( ( error ) => {
                    console.error( error )
                } )
        } else {
            setIsLoading(false);
            setIsError(false);
            setShowInfoPanel(true);
            setSuggestions([]);
            setMessage('Type at least three characters to get suggestions');
        }

    }

    const onSuggestionsFetchRequested = ( { value } ) => {
        getSuggestions( value )
    };

    const onSuggestionsClearRequested = () => {
        setIsLoading(false);
        setSuggestions([]);
        setMessage('Type at least three characters to get suggestions');

    };

    const processSelection = ( suggestion ) => {
        if ( suggestion ) {
            setSelectedId(suggestion.id)
        } else {
            setSelectedId(null)
        }
        // document.querySelectorAll("#jobTitle")[0].value = "";
        props.handleChange( { name: "salesOrg", value: suggestion.sales_org_id || "" } )
        props.handleChange( { name: "author", value: suggestion.id || "" } )
        document.querySelectorAll( "#salesOrg_name" )[0].value = suggestion.sales_org_name ? suggestion.sales_org_name.replace( "Werfen ", "" ) : "";
    }

    const onSuggestionSelected = ( event, { suggestion } ) => {
        processSelection( suggestion );
    }

    const shouldRenderSuggestions = ( value, reason ) => {
        return reason === 'input-focused' && value.trim().length > 2 && suggestions.length > 1;
    }

    const onBlur = () => {
        setShowInfoPanel(false)
    }


        const { fieldId, label, isDisabled, placeholder, isRequired } = props
        // Autosuggest will pass through all these props to the input.
        const inputProps = {
            placeholder,
            value,
            onChange: onChange,
            disabled: isDisabled,
            className: "form-control",
            autoComplete: "off",
            autoCorrect: "off",
            autoCapitalize: "off",
            spellCheck: "false",
            onBlur: onBlur,
        };

        return (
            <StyledFormGroup id={ fieldId }>
                <label>
                    { label }
                    { isRequired === true && <span style={ { color: "red" } }> *</span> }
                </label>
                <Autosuggest
                    suggestions={ suggestions || [] }
                    alwaysRenderSuggestions={ true }
                    shouldRenderSuggestions={ shouldRenderSuggestions }
                    onSuggestionSelected={ onSuggestionSelected }
                    onSuggestionsFetchRequested={ onSuggestionsFetchRequested }
                    onSuggestionsClearRequested={ onSuggestionsClearRequested }
                    getSuggestionValue={ getSuggestionValue }
                    renderSuggestion={ renderSuggestion }
                    inputProps={ inputProps }
                />
                { (isLoading || isError || showInfoPanel) &&
                <div className={ "infoPanel" }>{ message }</div>
                }
                <input
                    type="hidden"
                    name="author"
                    value={ selectedId }
                />
            </StyledFormGroup>
        )
}

export default AutosuggestField